import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53e2f302"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = {
  class: "display-flex margin-top",
  style: {"height":"calc(100% - 200px)"}
}
const _hoisted_3 = { class: "faq-table-div margin-top-100" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "m-0 p-0 faq-table-title" }, "All FAQs", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search searchicon" }, null, -1 /* HOISTED */))
const _hoisted_6 = { class: "scroll-table faq_table" }
const _hoisted_7 = {
  class: "table m-0",
  rules: "groups"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "width-10" }, "■", -1 /* HOISTED */))
const _hoisted_9 = { class: "subject_td" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text-center",
  style: {"font-style":"italic"}
}, "No data.", -1 /* HOISTED */))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { style: {"margin-top":"5px","float":"right"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-caret-left-fill" }),
  /*#__PURE__*/_createTextVNode("Back")
], -1 /* HOISTED */))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createVNode($setup["Navigation"]),
    _createVNode($setup["Alert"], {
      alertMessage: $setup.alertMessage,
      alertState: $setup.alertState
    }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" FAQ Table Start "),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "search",
          name: "search",
          placeholder: " Search...",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.search) = $event)),
          onKeyup: $setup.changeEvent
        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelText, $setup.search]
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.faqInfo, (info, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _hoisted_8,
                  _createElementVNode("td", _hoisted_9, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: ($event: any) => ($setup.showFaq(info.Content))
                    }, _toDisplayString(info.Subject), 9 /* TEXT, PROPS */, _hoisted_10)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              ($setup.faqInfo.length == 0 && $setup.getData)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, _hoisted_13))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary button-margin button-width",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.linkBack()))
          }, _hoisted_16)
        ])
      ]),
      _createCommentVNode(" FAQ Table End ")
    ])
  ]))
}